/**
 * Save vs Send sponsor gates (#999 Story 3.8 / #1401).
 *
 * Manual Save (persist, stay on stage) must not re-check Vertiv Sponsor past
 * Draft. Stage advances are handoffs and still require ≥1 sponsor.
 */

export function requiresVertivSponsorForManualSave(): boolean {
  return false;
}

/**
 * True when advancing from one request stage to another (handoff).
 * Includes Draft → Site Assessment and Send to Config / later advances.
 * Missing current stage still requires sponsor (fail closed).
 */
export function requiresVertivSponsorForStageAdvance(
  currentStage: string | null | undefined,
  nextStage: string | null | undefined,
): boolean {
  if (!nextStage) {
    return false;
  }
  if (!currentStage) {
    return true;
  }
  return currentStage !== nextStage;
}

export function normalizeVertivSponsors(sponsors: unknown): string[] {
  let value = sponsors;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value) as unknown;
    } catch {
      return [];
    }
  }
  if (!Array.isArray(value)) {
    return [];
  }
  return value.filter(
    (entry): entry is string => typeof entry === 'string' && entry.length > 0,
  );
}

export function hasVertivSponsorSelection(sponsors: unknown): boolean {
  return normalizeVertivSponsors(sponsors).length > 0;
}
